const DownloadSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.66797 11.3327V12.666C2.66797 13.0196 2.80844 13.3588 3.05849 13.6088C3.30854 13.8589 3.64768 13.9993 4.0013 13.9993H12.0013C12.3549 13.9993 12.6941 13.8589 12.9441 13.6088C13.1942 13.3588 13.3346 13.0196 13.3346 12.666V11.3327M4.66797 7.33268L8.0013 10.666M8.0013 10.666L11.3346 7.33268M8.0013 10.666V2.66602"
        stroke="#333333"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadSvg;
